import React, { ReactElement } from 'react'
import { Flex, Text } from 'theme-ui'
import CONTROLDLogo, { CONTROLDText } from 'ui/CONTROLD'
import Devices from 'images/homePage/devices.svg'
import DNShostname from 'images/homePage/dns-hostname.svg'
import DNSsettings from 'images/homePage/dns-settings.svg'
import NextArrow from 'images/homePage/next-arrow.svg'
import { Svg } from 'ui'

const title = (
  <>
    How do I use <CONTROLDLogo Dsx={{ ml: '1.2rem' }} />?
  </>
)

const description = (
  <>
    To start using {CONTROLDText}, you need to change just one setting on any device you want to use
    it on - this setting is your device&apos;s DNS server. We&apos;ll guide you through how to do
    that after you get started, or you can take a peek at our knowledge base. Once you&apos;ve
    changed this setting, your device will utilize your {CONTROLDText} profile whenever you&apos;re
    using the internet.
  </>
)

export default function HowDoIUseControlDSection(): ReactElement {
  return (
    <Flex
      sx={{
        pt: ['2.4rem', '3.2rem'],
        px: ['1.6rem', '4.8rem'],
        borderRadius: '32px',
        mt: '4rem',
        justifyContent: 'center',
        alignSelf: 'center',
        width: '100%',
      }}
    >
      <Flex
        sx={{
          flexDirection: 'column',
          width: ['fit-content', 'fit-content', '100%'],
          textAlign: ['center', 'center', 'left'],
        }}
      >
        <Text
          as="h2"
          sx={{
            fontSize: ['2.8rem', '4rem'],
            mb: ['2.4rem', '3.2rem'],
            fontWeight: 'bold',
          }}
        >
          {title}
        </Text>
        <Text
          sx={{
            fontSize: ['1.8rem', '2.1rem'],
            color: 'aliceBlue60',
          }}
        >
          {description}
        </Text>
        <Flex
          sx={{
            mt: ['1rem', 0, '2rem'],
            flexDirection: ['column', 'column', 'row'],
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Svg svg={Devices} descriptiveText="Supported devices illustration" />
          <Svg
            svg={NextArrow}
            sx={{
              transform: ['rotate(90deg)', 'rotate(90deg)', 'none'],
              my: ['-1rem', '-1rem', 0],
            }}
            descriptiveText="Next step arrow"
          />
          <Svg svg={DNSsettings} descriptiveText="DNS settings configuration illustration" />
          <Svg
            svg={NextArrow}
            sx={{
              transform: ['rotate(90deg)', 'rotate(90deg)', 'none'],
              my: ['-1rem', '-1rem', 0],
            }}
            descriptiveText="Next step arrow"
          />
          <Svg svg={DNShostname} descriptiveText="DNS hostname configuration illustration" />
        </Flex>
      </Flex>
    </Flex>
  )
}
